import { InstallMethodType } from "@/types/frontend";
import { OneIdWidget } from "./OneIdWidget";
import _ from "lodash";

declare global {
    interface Window {
        OneIdApi: WidgetJSAPI;
    }
}

export interface WidgetOptions {
    container: HTMLElement; // an element in which to insert the widget
    verifyAge: number; // an age to verify
    installMethod: InstallMethodType;
    toggleCheckout?: boolean;
}

export interface WidgetInstance {
    destroy(): void; // destroy the widget
}

export class WidgetJSAPI {
    widget = {} as OneIdWidget;
    initialize(options: WidgetOptions): OneIdWidget {
        let toggleCheckout: boolean = false;

        if (_.hasIn(options, "toggleCheckout")) {
            toggleCheckout = options.toggleCheckout!;
        }

        this.widget = new OneIdWidget(
            options.container,
            options.verifyAge,
            options.installMethod,
            toggleCheckout

        ); // set options
        this.widget.initialize();

        return this.widget;
    }
    destroy(): void{
        this.widget.destroy();
    }
}
